<template>
    <kt-row>
        <kt-col lg="6" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="pin">
                    {{ $t('label.pin') }}
                </kt-form-label>
                <kt-form-control
                        id="pin"
                        name="pin"
                        v-model="psp_request.port_config.pin"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
    </kt-row>
</template>

<script>
export default {
    props: {
        psp_request: {
            required: true,
            type: Object,
            default() {
                return {}
            }
        }
    }
}
</script>

<style>
</style>